export default "__VITE_ASSET__BlKrd2VA__"